function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M34.61 31V5a5 5 0 00-5-5H5a5 5 0 00-5 5v4.21h8V35a5 5 0 005 5h21.7a5 5 0 005-5v-4zM8 7.23H2V5a3 3 0 016 0v2.23zM16 35a3 3 0 01-6 0V5a5 5 0 00-1-3h20.7a3 3 0 013 3v26H16v4zm21.7 0a3 3 0 01-3 3H16.92a4.92 4.92 0 001-3v-2h19.74v2zM15.81 8.38h11.43v-2H15.81zm0 4.85h11.43v-2H15.81zm0 4.85h11.43v-2H15.81zm0 4.85h11.43V21H15.81zm0 4.85h11.43v-2H15.81z",
  fillRule: "evenodd"
});

function SvgRegister(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 39.63 40"
  }, props), _ref);
}

export default __webpack_public_path__ + "assets/images/register.7204f03a.svg";
export { SvgRegister as ReactComponent };